import React, { useEffect, useState, forwardRef, useImperativeHandle } from "react";
import type {
  UnitPriceItem,
} from "@/types/product";
import type { SpecsItemDetail } from "./types";
import styles from "./Total.module.less";
import { t } from "@/utils/i18n";
import useCorpSettingStore from "@/stores/corp-setting";
import Currency from "@/components/Currency/Currency";
import { cal } from "@/utils";

interface Details {
  [key: string]: SpecsItemDetail
}

interface TotalProps {
  productPrice: number // 货品金额
  details: Details
  chooseUnit: UnitPriceItem
  baseUnit: UnitPriceItem
  isMultiPrice: boolean
  productMoqUnitIndex: number
  [key: string]: any
  onConfirmBill: () => void
  onremoveBil?: () => void
}

const Total: React.FC<TotalProps> = forwardRef((props, ref) => {
  const {
    productPrice,
    details,
    chooseUnit,
    baseUnit,
    isMultiPrice,
    productMoqUnitIndex,
    onConfirmBill,
  } = props

  const { corpSetting } = useCorpSettingStore();
  const { currencySymbol, pricePrecision } = corpSetting;
  const [disable, setDisable] = useState(false);
  const [startQuantityLeft, setStartQuantityLeft] = useState(0);
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [baseUnitTotalQuantity, setBaseUnitTotalQuantity] = useState(0); // 基础单位总数量
  const [totalMoney, setTotalMoney] = useState(0);

  useImperativeHandle(ref, () => ({
    disable,
    totalMoney,
    totalQuantity,
  }))

  /*
  * 加入购物车 统计总数量、总金额
  */
  function sum() {
    let totalQuantity = 0;
    let totalMoney = 0;
    let disable = false;
    let startQuantityLeft = 0;

    const list: SpecsItemDetail[] = Object.values(details)

    // 总数量
    totalQuantity = list.reduce((prev, next: SpecsItemDetail) => {
      return cal.plus(prev, next.quantity || 0);
    }, 0);

    // 总金额
    if (isMultiPrice) {
      // 不同规格不同价格
      // 计算基础单位总计
      totalMoney = list
      .filter((item) => item.quantity > 0)
      .reduce((prev, next) => {
        return cal.plus(prev, cal.times(next.quantity, next.price || 0));
      }, 0);
      // 计算起订单位总计
      totalMoney = cal.times(totalMoney, chooseUnit.unitRatio)
      totalMoney = cal.getCarry(
        pricePrecision,
        totalMoney,
      ) || 0;
    } else {
      totalMoney = cal.getCarry(pricePrecision, cal.times(totalQuantity, productPrice)) || 0;
    }

    // 起订量
    if (chooseUnit.productMoqQty) {
      const startQuantity = chooseUnit.productMoqQty;
      if (startQuantity > 0) {
        startQuantityLeft = cal.minus(startQuantity, totalQuantity);
        disable = startQuantityLeft > 0;
      }
    }

    // 起订单位索引大于基础单位索引计算基础单位总计
    if (productMoqUnitIndex > 0) {
      setBaseUnitTotalQuantity(cal.times(totalQuantity, chooseUnit.unitRatio));
    }

    setTotalQuantity(totalQuantity);
    setTotalMoney(totalMoney);
    setDisable(disable);
    setStartQuantityLeft(startQuantityLeft);
  }

  useEffect(() => {
    sum()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [details])

  return (
    <div className={styles['total-wrap']}>
      <div className={styles["sum-bar"]}>
        {disable && (
          <div className={styles["start-quantity-bar"]}>
            {t("最低起订量")}
            {chooseUnit.productMoqQty}
            {chooseUnit.unitName}
            {t("，还差")}
            {startQuantityLeft}
            {chooseUnit.unitName}。
          </div>
        )}
        <div className={styles['sum-bar-bd']}>
          <div className={styles["sum-bar-item"]}>
            {t("总 数")}
            <div className={styles['sum-bar-item-bd']}>
              <span className={styles["sum-bar-num"]}>{totalQuantity}{baseUnitTotalQuantity > 0 ? `(${baseUnitTotalQuantity}${baseUnit.unitName})` : ''}</span>
            </div>
          </div>
          <div className={styles["sum-bar-item"]}>
            {t("总金额")}
            <div className={styles['sum-bar-item-bd']}>
              <div className={styles["sum-bar-num"]}>
                <Currency
                  currencyUnit={currencySymbol}
                  money={totalMoney}
                  unitSize={28}
                  moneySize={32}
                  precision={pricePrecision}
                />
                {/* 隐藏VAT */}
                {/* <span className={styles["tax-tag"]}>{t("不含税")}</span> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles["confirm-button-wrapper"]}>
        {/* {!!product.saleProduct && (
          <div
            className={styles["confirm-button"] + " " + styles["confirm-button-remove"]}
            hover-class="remove-btn-hover"
            onClick={removeBill}
          >
            {t("移出购物车")}
          </div>
        )} */}
        <button
          className={styles["confirm-button"]}
          hover-class="sure-btn-hover"
          onClick={onConfirmBill}
        >
          {t("确认")}
        </button>
      </div>
    </div>
  );
});

export default Total